import { peerCoachingService } from '@/src/services/safehaven/PeerCoachingService'
export const state = {
  reasonProvider: null,
}

export const getters = {
  getReasonProviderDetails: (state) => {
    return state.reasonProvider ? state.reasonProvider : null
  },
}

export const mutations = {
  SET_REASON_PROVIDER_DETAILS(state, newValue) {
    state.reasonProvider = newValue
  },
}

export const actions = {
  async setReasonProviderDetails({ commit, state }) {
    await peerCoachingService.getReasonProviderType().then((response) => {
      if (response.status === 200) {
        commit('SET_REASON_PROVIDER_DETAILS', response.data)
        return response.data
      }
    })
  },
}
